/* eslint-disable */

import { generic_service } from '../_utilities/generic.js'
import api from '../_api'

const genericProfileService = (pathname) => ({
  getAllProfilesStats(range) {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
    return api.get('/profile/stats_range/', {
      params: { range, userTimezone },
    })
  },
  getProfileStats(pk, range) {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
    return api.get(`/profile/${pk}/single_stats_range/`, {
        params: { range , userTimezone}
    })
  },
  getStylistGroups(id, payload) {
    return api.get(`/customer-group/${id}/assigned_stylist/`, { params: payload })
  },
  getSalesOverviewData(id) {
    return api.get(`profile/${id}/sales_overview/`);
  },
  getCustomSalesOverviewData(url, payload) {
    return api.get(url, {params: payload})
  },
  getOrderedItems(payload) {
    return api.get(`profile/assign_list/`, {params: payload});
  },
  // Doesn't actually fetch team
  fetchTeam(url) {
    return api.get(url);
  },
  ...generic_service(pathname),
})

export default genericProfileService;
